import { Injector, Type } from '@angular/core';
import { SgAsyncGuiRef } from './async-gui-ref';

export type SgAsyncGuiPhaseType = 'run' | 'resolve' | 'reject';

export type SgAsyncGuiContent = {
  title?: string;
  message: string;
  icon?: string;
};
export type SgAsyncGuiEventType = 'userCloseRequested' | 'forceClosing';

export interface SgAsyncGuiEvent {
  name: 'event';
  type: SgAsyncGuiEventType;
}
export interface SgAsyncGuiPhase {
  name: 'phase';
  type: SgAsyncGuiPhaseType;
}

export type SgAsyncGuiScrollStrategies = 'noop' | 'block' | 'reposition' | 'close';

export interface SgAsyncGuiPlugins {}

export interface SgAsyncGuiPlugin {
  readonly name: keyof SgAsyncGuiPlugins;
  open(promise: Promise<any>, context: SgAsyncGuiPluginContext): SgAsyncGuiRef;
}

export interface SgAsyncGuiPluginContext {
  injector: Injector;
  options: SgAsyncGuiOptions;
  component: Type<any>;
}

export interface SgAsyncGuiOptions<T = any> {
  style: keyof SgAsyncGuiPlugins;
  applyOn?: SgAsyncGuiPhaseType[];
  component?: Type<any>;
  data?: T;
}

export function isAsyncGuiEvent(item: SgAsyncGuiEvent | SgAsyncGuiPhase): item is SgAsyncGuiEvent {
  return item.name === 'event';
}
export function isAsyncGuiPhase(item: SgAsyncGuiEvent | SgAsyncGuiPhase): item is SgAsyncGuiPhase {
  return item.name === 'phase';
}
